__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/ecb6b0d/_next/";